import { AlertColor, Box } from '@mui/material';
import { AlertBoxMsg } from '@qrios/frontend-library';
import { FormikErrors, FormikTouched } from 'formik';
import { ChangeEvent, useContext, FormEvent, ReactNode } from 'react';

import WithFormLayout from '../../with-form-layout';

import { FiltersFormType } from '../interfaces';
import { LocalesContext } from '../localesContext';

interface Props<T> {
  handleChange: (field: string, value: unknown) => void;
  handleBlur: (e: ChangeEvent) => void;
  values: T & { name: string };
  errors: FormikErrors<T>;
  generatedBusinessError?: ReactNode;
  generatedBusinessErrorSeverity?: AlertColor;
  touched: FormikTouched<T>;
  handleSubmit: () => void;
  reportGenerating: boolean;
  filtersForm: FiltersFormType<T>;
}

const FiltersForm = ({
  handleChange,
  handleBlur,
  values,
  errors,
  touched,
  handleSubmit,
  reportGenerating,
  generatedBusinessError,
  generatedBusinessErrorSeverity,
  filtersForm
}: Props<unknown>) => {
  const locales = useContext(LocalesContext);

  const onSubmit = (event: FormEvent<HTMLFormElement>) => {
    event.preventDefault();
    handleSubmit();
  };

  return (
    <WithFormLayout
      loading={reportGenerating}
      onSubmit={onSubmit}
      submitLabel="Generate report"
      formInfoText={
        <>
          Select filters for <b>{values.name}</b> report
        </>
      }
    >
      {filtersForm({
        values,
        errors,
        touched,
        handleChange,
        handleBlur,
        locales
      })}
      {generatedBusinessError && generatedBusinessErrorSeverity ? (
        <Box pb={1}>
          <AlertBoxMsg severity={generatedBusinessErrorSeverity}>{generatedBusinessError}</AlertBoxMsg>
        </Box>
      ) : null}
    </WithFormLayout>
  );
};

export default FiltersForm;
